import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, loginModal } from '../../../Redux/authAction';
import { auth } from '../../../FirebaseConfig'; 
import {
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  updateProfile,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import Goo from "../../../assets/icons/Picture1.png"
import loginImage from '../../../assets/home/gmail.jpg';
import api from '../../../config/api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'clamp(750px,100%,300px)',
  height: '600px',
  bgcolor: 'background.paper',
  border: '0px solid #000',
  boxShadow: 24,
  p: 4,
};

const LoginModal = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [isSignUp, setIsSignUp] = useState(false);
  const [logName, setLogName] = useState('');
  const [logEmail, setLogEmail] = useState('');
  const [logPassword, setLogPassword] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        const { displayName, email, uid } = user;
        dispatch(loginUser({ displayName, email, uid }));
        onClose();
      })
      .catch((error) => {
        console.error('Google login error:', error);
      });
  };

  const handleSignup = async () => {
    try {
      if (logName && logEmail && logPassword) {
        const userCredential = await createUserWithEmailAndPassword(auth, logEmail, logPassword);
        await updateProfile(userCredential.user, { displayName: logName });
        const user = userCredential.user;
        const { displayName, email, uid } = user;
        dispatch(loginUser({ displayName, email, uid }));
        setSnackbarSeverity('success');
        setSnackbarMessage('Signup successful!');
        setSnackbarOpen(true);
        onClose();
      } else {
        setSnackbarSeverity('error');
        setSnackbarMessage('Please enter valid name, email, and password.');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Signup error:', error);
      setSnackbarSeverity('error');
      setSnackbarMessage('An error occurred during signup.');
      setSnackbarOpen(true);
    }
  };

  
  const handleLogin = async () => {
   
    try {
      if (logEmail && logPassword) {
        // Sign in with email and password
        const userCredential = await signInWithEmailAndPassword(auth, logEmail, logPassword);
        const user = userCredential.user;
        const { displayName, email, uid } = user; // Fix: Renamed email_ back to email
        console.log("The display name is  :" + displayName);
        console.log("The email is  :" + email); // Fix: Correct variable name
        console.log("The UID is  :" + uid);
        
        // Send UID to fetch subscription data
        const formData = new FormData();
        formData.append("uid", uid);
  
        const response = await fetch(api.getUrl(api.ENDPOINTS.GET_SUBSCRIPTION_DATA), {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch subscription data.");
        }
  
        const data = await response.json();
  
        if (data.status === "success" && data.data.length > 0) {
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
          const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
        
          // Dispatch login details to Redux
          dispatch(loginUser({ displayName, email, uid, packageid, status , temp_pkgid})); // Fix: Using 'email' here
  
          console.log("The ID from redux name is  ------------------------ >  :" + packageidid);
          console.log("The UID from redux name is  ------------------------ >  :" + uid);
          // Show success snackbar
          setSnackbarSeverity("success");
          setSnackbarMessage(isLang === "arabic" ? "تسجيل الدخول بنجاح!" : "Login successful!");
          setSnackbarOpen(true);
  
          // Close login modal
          dispatch(loginModal(false));
          handleCloseModel();
        } else {
          // If no subscription found, show an error
          setSnackbarSeverity("error");
          setSnackbarMessage(isLang === "arabic" ? "لم يتم العثور على اشتراك." : "No subscription found.");
  
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
        
          const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid); // Moved outside
        
          dispatch(loginUser({ displayName, email, uid,packageid,status, temp_pkgid}));
  
          console.log("The ID from redux name is  ------------in case of no data------------ >  :" + packageidid);
          setSnackbarOpen(true);
          handleCloseModel();
        }
      } else {
        // If email or password is missing, show an error
        setSnackbarSeverity("error");
        setSnackbarMessage(isLang === "arabic" ? "يرجى إدخال البريد الإلكتروني وكلمة المرور." : "Please enter both email and password.");
        setSnackbarOpen(true);
        handleCloseModel();
      }
    } catch (error) {
      console.error("Login Error:", error.message);
  
      // Show error snackbar
      setSnackbarSeverity("error");
      setSnackbarMessage(isLang === "arabic" ? "فشل تسجيل الدخول. تحقق من بياناتك." : "Failed to login. Please check your credentials.");
      setSnackbarOpen(true);
      handleCloseModel();
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style} className="rounded-lg text-[#262b33]">
          <div className="flex items-end justify-end" onClick={onClose}>
            <p className="text-black p-1 text-lgs font-semibold hover:text-red-700" style={{ fontFamily: 'poppins', fontSize: '16px' }}>
              X
            </p>
          </div>
          <div className="flex">
            <div className="w-[50%] h-[70vh] flex flex-col gap-4 mr-7 ml-2">
              <p className="mb-[30px] mt-[20px] text-[24px] font-[700] relative -left-3">
                {isSignUp ? 'Sign Up' : 'Sign In'}
              </p>
              {isSignUp && (
                <div>
                  <p>Display Name:</p>
                  <input
                    type="text"
                    placeholder="Full Name"
                    value={logName}
                    onChange={(e) => setLogName(e.target.value)}
                    className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                  />
                </div>
              )}
              <div>
                <p>Email:</p>
                <input
                  type="text"
                  placeholder="Email"
                  value={logEmail}
                  onChange={(e) => setLogEmail(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
              <div>
                <p>Password:</p>
                <input
                  type="password"
                  placeholder="Password"
                  value={logPassword}
                  onChange={(e) => setLogPassword(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
              <button
                onClick={isSignUp ? handleSignup : handleLogin}
                className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer"
              >
                {isSignUp ? 'Sign Up' : 'Login'}
              </button>
              <button
                onClick={handleGoogleLogin}
                className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                <img src={Goo} className="h-8" alt="Google Logo" />
                <span>Continue with Google</span>
              </button>
              <div style={{ display: 'flex', gap: '4px' }}>
                <p>{isSignUp ? 'Already have an account?' : "Don't have an account?"}</p>{' '}
                <button
                  onClick={() => setIsSignUp(!isSignUp)}
                  className="focus:outline-none active:outline-none text-[#3b603d] font-[600] hover:underline"
                >
                  {isSignUp ? 'Login' : 'Sign Up'}
                </button>
              </div>
            </div>
            <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
              <img src={loginImage} className="h-full" alt="Login" />
            </div>
          </div>
        </Box>
      </Modal>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default LoginModal;
